var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            "aria-label": "員工入口",
                            label: this.language["emp.develop.empEntrance"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "entranceList"
                          }
                        },
                        [
                          _c(
                            "a-checkbox-group",
                            {
                              attrs: { disabled: _vm.formDisabled },
                              on: { change: _vm.handleChangeEntrance },
                              model: {
                                value: _vm.model.entranceList,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "entranceList", $$v)
                                },
                                expression: "model.entranceList"
                              }
                            },
                            _vm._l(_vm.entranceOptions, function(item, index) {
                              return _c(
                                "a-checkbox",
                                { key: index, attrs: { value: item.value } },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._l(_vm.selectedEntrances, function(item, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _c(
                          "a-form-model-item",
                          {
                            staticClass: "requiredCss",
                            attrs: {
                              "aria-label": "应用分类",
                              label:
                                _vm.language["emp.develop.appType"] +
                                _vm.cale(item),
                              labelCol: _vm.labelCol,
                              wrapperCol: _vm.wrapperCol
                            }
                          },
                          [
                            _c(
                              "a-select",
                              {
                                attrs: {
                                  "show-search": "",
                                  placeholder:
                                    _vm.language["column.pleaseChoose"] +
                                    _vm.language["emp.develop.appType"],
                                  disabled: _vm.formDisabled
                                },
                                model: {
                                  value: _vm.appData[index],
                                  callback: function($$v) {
                                    _vm.$set(_vm.appData, index, $$v)
                                  },
                                  expression: "appData[index]"
                                }
                              },
                              _vm._l(
                                _vm.apptypeOptions.filter(function(temp) {
                                  return temp.entranceId === item
                                }),
                                function(item1, index) {
                                  return _c(
                                    "a-select-option",
                                    {
                                      key: index,
                                      attrs: {
                                        value: item1.value,
                                        allowClear: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item1.label) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                }
                              ),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["emp.develop.appName"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "applicationName"
                          }
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "85%" },
                            attrs: {
                              placeholder:
                                this.language["basedata.pleaseEnter"] +
                                this.language["emp.develop.appName"],
                              disabled: true
                            },
                            model: {
                              value: _vm.model.applicationName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applicationName", $$v)
                              },
                              expression: "model.applicationName"
                            }
                          }),
                          _c(
                            "a-button",
                            {
                              staticStyle: { left: "3%" },
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.languageModelOpen(
                                    "emp_dev_app_apply",
                                    "application_name",
                                    _vm.applicationNameLanguages
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.language["common.language"]))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["emp.develop.appCode"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "applicationCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                this.language["basedata.pleaseEnter"] +
                                this.language["emp.develop.appCode"],
                              disabled: true
                            },
                            model: {
                              value: _vm.model.applicationCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applicationCode", $$v)
                              },
                              expression: "model.applicationCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["emp.develop.appIcon"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "applicationImgPath"
                          }
                        },
                        [
                          _c("j-image-upload", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.model.applicationImgPath,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applicationImgPath", $$v)
                              },
                              expression: "model.applicationImgPath"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["emp.develop.appDesc"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "applicationDesc"
                          }
                        },
                        [
                          _c("a-textarea", {
                            staticStyle: { width: "85%" },
                            attrs: {
                              placeholder:
                                this.language["basedata.pleaseEnter"] +
                                this.language["emp.develop.appDesc"],
                              disabled: true,
                              rows: "4"
                            },
                            model: {
                              value: _vm.model.applicationDesc,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applicationDesc", $$v)
                              },
                              expression: "model.applicationDesc"
                            }
                          }),
                          _c(
                            "a-button",
                            {
                              staticStyle: { left: "3%" },
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.languageModelOpen(
                                    "emp_dev_app_apply",
                                    "application_desc",
                                    _vm.applicationDescLanguages
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.language["common.language"]))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "joinType",
                            "aria-label": "应用中心加入类型",
                            label: _vm.language["emp.develop.joinTypeTitle"]
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              allowClear: true,
                              dictCode: "emp_application_jointype",
                              disabled: true
                            },
                            model: {
                              value: _vm.model.joinType,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "joinType", $$v)
                              },
                              expression: "model.joinType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      this.model.joinType == "link"
                        ? _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                "aria-label": "应用URL（测试）",
                                label: _vm.language["emp.develop.appUrlTest"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "applicationTestUrl"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["emp.develop.appUrlTest"]
                                },
                                model: {
                                  value: _vm.model.applicationTestUrl,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "applicationTestUrl",
                                      $$v
                                    )
                                  },
                                  expression: "model.applicationTestUrl"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      this.model.joinType == "link"
                        ? _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                "aria-label": "应用URL（正式）",
                                label: _vm.language["emp.develop.appUrlProd"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "applicationProdUrl"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["emp.develop.appUrlProd"]
                                },
                                model: {
                                  value: _vm.model.applicationProdUrl,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "applicationProdUrl",
                                      $$v
                                    )
                                  },
                                  expression: "model.applicationProdUrl"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      this.model.joinType == "sso"
                        ? _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                "aria-label": "SSO回传URL（测试）",
                                label: _vm.language["emp.develop.ssoUrlTest"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "applicationTestUrl"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["emp.develop.ssoUrlTest"]
                                },
                                model: {
                                  value: _vm.model.applicationTestUrl,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "applicationTestUrl",
                                      $$v
                                    )
                                  },
                                  expression: "model.applicationTestUrl"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      this.model.joinType == "sso"
                        ? _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                "aria-label": "SSO回传URL（正式）",
                                label: _vm.language["emp.develop.ssoUrlProd"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "applicationProdUrl"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["emp.develop.ssoUrlProd"]
                                },
                                model: {
                                  value: _vm.model.applicationProdUrl,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "applicationProdUrl",
                                      $$v
                                    )
                                  },
                                  expression: "model.applicationProdUrl"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      this.model.joinType == "authorize"
                        ? _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                "aria-label": "应用授权URL（测试）",
                                label: _vm.language["emp.develop.authUrlTest"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "applicationAuthTestUrl"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: "请输入应用授权URL（测试）"
                                },
                                model: {
                                  value: _vm.model.applicationAuthTestUrl,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "applicationAuthTestUrl",
                                      $$v
                                    )
                                  },
                                  expression: "model.applicationAuthTestUrl"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      this.model.joinType == "authorize"
                        ? _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                "aria-label": "应用授权URL（正式）",
                                label: _vm.language["emp.develop.authUrlProd"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "applicationAuthProdUrl"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["emp.develop.authUrlProd"]
                                },
                                model: {
                                  value: _vm.model.applicationAuthProdUrl,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "applicationAuthProdUrl",
                                      $$v
                                    )
                                  },
                                  expression: "model.applicationAuthProdUrl"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      this.model.joinType == "authorize"
                        ? _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                "aria-label": "免登录URL（测试）",
                                label:
                                  _vm.language["emp.develop.ssoLoginUrlTest"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "applicationTestUrl"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["emp.develop.ssoLoginUrlTest"]
                                },
                                model: {
                                  value: _vm.model.applicationTestUrl,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "applicationTestUrl",
                                      $$v
                                    )
                                  },
                                  expression: "model.applicationTestUrl"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      this.model.joinType == "authorize"
                        ? _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                "aria-label": "免登录URL（正式）",
                                label:
                                  _vm.language["emp.develop.ssoLoginUrlProd"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "applicationProdUrl"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["emp.develop.ssoLoginUrlProd"]
                                },
                                model: {
                                  value: _vm.model.applicationProdUrl,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "applicationProdUrl",
                                      $$v
                                    )
                                  },
                                  expression: "model.applicationProdUrl"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["system.user.name"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "applyAccount"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "", disabled: true },
                            model: {
                              value: _vm.model.applyAccount,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applyAccount", $$v)
                              },
                              expression: "model.applyAccount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["portal.personalName"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "applyName"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "", disabled: true },
                            model: {
                              value: _vm.model.applyName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applyName", $$v)
                              },
                              expression: "model.applyName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["column.mailbox"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "applyEmail"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "", disabled: true },
                            model: {
                              value: _vm.model.applyEmail,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applyEmail", $$v)
                              },
                              expression: "model.applyEmail"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["column.Landline"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "applyTelephone"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "", disabled: true },
                            model: {
                              value: _vm.model.applyTelephone,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applyTelephone", $$v)
                              },
                              expression: "model.applyTelephone"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["emp.develop.applyNo"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "applyNo"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "", disabled: true },
                            model: {
                              value: _vm.model.applyNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "applyNo", $$v)
                              },
                              expression: "model.applyNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["basedata.remark"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "remark"
                          }
                        },
                        [
                          _c("a-textarea", {
                            attrs: {
                              rows: "2",
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["basedata.remark"]
                            },
                            model: {
                              value: _vm.model.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "remark", $$v)
                              },
                              expression: "model.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "auditStatus",
                            "aria-label": "状态",
                            label: _vm.language["emp.apptype.status"]
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              allowClear: true,
                              dictCode: "emp_application_audit_status",
                              disabled: true
                            },
                            model: {
                              value: _vm.model.auditStatus,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "auditStatus", $$v)
                              },
                              expression: "model.auditStatus"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _vm.model.auditStatus != "approving"
                        ? _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["common.auditTime"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "auditTime"
                              }
                            },
                            [
                              _c("j-date", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "",
                                  showTime: true,
                                  "date-format": "YYYY-MM-DD HH:mm:ss",
                                  disabled: true
                                },
                                model: {
                                  value: _vm.model.auditTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "auditTime", $$v)
                                  },
                                  expression: "model.auditTime"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _vm.model.auditStatus != "approving"
                        ? _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["common.auditor"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "auditor"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "", disabled: true },
                                model: {
                                  value: _vm.model.auditor,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "auditor", $$v)
                                  },
                                  expression: "model.auditor"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _vm.model.auditStatus != "approving"
                        ? _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language[
                                  "portal.ui2.approvalComment"
                                ],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "auditRemark"
                              }
                            },
                            [
                              _c("a-textarea", {
                                attrs: {
                                  placeholder:
                                    this.language["basedata.pleaseEnter"] +
                                    this.language["portal.ui2.approvalComment"]
                                },
                                model: {
                                  value: _vm.model.auditRemark,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "auditRemark", $$v)
                                  },
                                  expression: "model.auditRemark"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c("language-model", {
        ref: "languageModel",
        on: { ok: _vm.languageOk }
      }),
      _vm.model.auditStatus == "approving" && this.auditFlag
        ? _c(
            "a-card",
            {
              attrs: {
                bordered: false,
                title: _vm.language["portal.ui2.approvalComment"]
              }
            },
            [
              _c(
                "div",
                [
                  _c(
                    "a-row",
                    [
                      _c("a-textarea", {
                        attrs: {
                          placeholder:
                            this.language["basedata.pleaseEnter"] +
                            this.language["portal.ui2.approvalComment"]
                        },
                        model: {
                          value: _vm.model.auditRemark,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "auditRemark", $$v)
                          },
                          expression: "model.auditRemark"
                        }
                      })
                    ],
                    1
                  ),
                  _c("br"),
                  _c(
                    "div",
                    { staticStyle: { "text-align": "center" } },
                    [
                      _c(
                        "a-button",
                        {
                          staticStyle: {
                            color: "blue",
                            right: "20px",
                            "padding-left": "30px",
                            "padding-right": "30px"
                          },
                          on: { click: _vm.agree }
                        },
                        [_vm._v(_vm._s(_vm.language["eletronicSigned.agree"]))]
                      ),
                      _c(
                        "a-button",
                        {
                          staticStyle: {
                            color: "red",
                            left: "20px",
                            "padding-left": "30px",
                            "padding-right": "30px"
                          },
                          on: { click: _vm.reject }
                        },
                        [_vm._v(_vm._s(_vm.language["eletronicSigned.reject"]))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }